.mq-form-section {
  display: flow-root;
  min-width: 0;
}
.mq-form-section-groups {
  display: flex;
  flex-direction: column;
  gap: var(--mq-section-gap);
}
/* Block flow owns separation only when no enclosing item already owns it. */
.mq-form-section:not(:first-child):not(.mq-form-section-first) {
  margin-block-start: var(--mq-section-gap);
}
.mq-form-section-body:not([hidden]) {
  display: flow-root;
  padding-block-start: var(--mq-space-sm);
}
.mq-form-section-body > :last-child {
  margin-block-end: 0;
}
.mq-form-section-heading-only {
  padding-block-end: var(--mq-space-sm);
}
.ck-space-item > .mq-form-section-heading-only {
  padding-block-end: 0;
}
.mq-form-section-heading > span:first-child {
  max-width: 100%;
}
.mq-form-section-heading-title {
  display: inline-flex;
  align-items: center;
  gap: var(--mq-space-sm);
  min-width: 0;
}
.mq-form-section-heading-extra {
  display: inline-flex;
  align-items: center;
}
.mq-form-section-heading > .ck-btn {
  flex: none;
}
